import React from 'react';
import {Box} from "@material-ui/core";
import upperFirst from "mn-utils/upperFirst";

import Caption from '../../../../dumb/Caption/C';
import {
  DisplayAmountMerchant,
  DisplayAmountFCMerchant,
  DisplayIdMerchant,
  DisplayDateTimeMerchant
} from "../../../../helpers/Display/DataDisplay";
import {TableStaticMerchant} from "../../../../helpers/Table";

export default (props) => {

  const items = props.items || [];
  const fiatCode = props.fiatCode || '';

  return (
    <>
      <Caption>Transactions</Caption>
      <Box height="calc(100vh - 625px)" minHeight="500px" mt="2rem">
        <TableStaticMerchant
          list={items}
          rowCount={items.length}

          columns={[
            {
              minWidth: 150,
              label: 'Trx Type',
              dataKey: 'transaction_type',
              dataHandler: ({transaction_type = ''}) => upperFirst(transaction_type)
            },
            {
              minWidth: 300,
              label: 'Trx ID',
              dataKey: 'transaction_id',
              dataHandler: ({transaction_id = ''}) => (
                <DisplayIdMerchant>
                  {transaction_id}
                </DisplayIdMerchant>
              )
            },
            {
              minWidth: 300,
              label: 'Order ID',
              dataKey: 'transaction_id',
              dataHandler: ({transaction_id = ''}) => (
                <DisplayIdMerchant>
                  {transaction_id}
                </DisplayIdMerchant>
              )
            },
            {
              minWidth: 150,
              label: 'Date',
              dataKey: 'transaction_id',
              dataHandler: ({date}) => (
                <DisplayDateTimeMerchant
                  date={date}
                />
              )
            },
            {
              minWidth: 150,
              label: 'Amount',
              dataKey: 'amount',
              dataHandler: (row) => {
                const currencyAmount = row.fiat_amount;

                const cryptoCurrencyAmount = row.cc_amount;
                const cryptoCurrencyCode = row.crypto_type;

                return (
                  <div>
                    <DisplayAmountFCMerchant
                      fiat={{amount: currencyAmount, symbol: fiatCode}}
                      crypto={cryptoCurrencyAmount ? {
                        amount: cryptoCurrencyAmount,
                        symbol: cryptoCurrencyCode,
                      } : {}}
                    />
                  </div>
                )
              }
            },
            {
              minWidth: 150,
              label: 'Fee',
              dataKey: 'fee',
              dataHandler: (row) => (
                <DisplayAmountMerchant
                  amount={row.lunu_fee}
                  symbol={fiatCode}
                  type="fiat"
                />
              )
            },
            {
              minWidth: 150,
              label: 'Account Balance',
              dataKey: 'account_balance',
              dataHandler: (row) => (
                <DisplayAmountMerchant
                  amount={row.account_balance}
                  symbol={fiatCode}
                  type="fiat"
                />
              )
            },
          ]}
        />
      </Box>
    </>
  )
}



// module.exports = withState(() => {
//   return (state, props) => {
//     const transactions = props.items || [];
//     const fiatCode = props.fiatCode || '';
//
//     return (
//       <section>
//         <div className="layoutRow fhaB fvaC">
//           <Caption>Transactions</Caption>
//           {/*<ReportDownload*/}
//           {/*  className="pl10"*/}
//           {/*  urlPrefix="/v2/console/report-withdraw/"*/}
//           {/*  prefix="pbl"*/}
//           {/*  filter={{id: props.id}}*/}
//           {/*  disablePrint*/}
//           {/*/>*/}
//         </div>
//
//         {/*pub transaction_type: MerchantTransactionType,*/}
//         {/*pub transaction_id: Uuid,*/}
//         {/*pub order_id: Option<Uuid>,*/}
//         {/*pub date: DateTime<Utc>,*/}
//         {/*  pub cc_amount: CurrencyAmount,*/}
//         {/*  pub crypto_type: AssetCode,*/}
//         {/*  pub fiat_amount: CurrencyAmount,*/}
//         {/*  pub lunu_fee: Option<CurrencyAmount>,*/}
//         {/*    /// This should be set manually after ordering.*/}
//         {/*    pub account_balance: Option<CurrencyAmount>,*/}
//
//         <div className="ovxA mt24">
//           <div className="wmin600">
//             <div className="bgE layoutRow fhaC fvaC r9 ttU ov ph20 w1/8>1">
//               <Col>Trx Type</Col>
//               <Col>Trx ID</Col>
//               <Col>Order ID</Col>
//               <Col>Date</Col>
//               <Col>CC Amount</Col>
//               <Col>Fiat Amount</Col>
//               <Col>Fee</Col>
//               <Col>Account Balance</Col>
//             </div>
//             <div className="hmax457 bs bcDADCE1 b bb1 ovx ovyA">
//               {map(transactions, (item) => {
//                 const {
//                   transaction_type: trxType,
//                   transaction_id: trxId,
//                   order_id: orderId,
//                   date,
//                   cc_amount: ccAmount,
//                   crypto_type: ccCode,
//                   fiat_amount: fiatAmount,
//                   lunu_fee: fee,
//                   account_balance: accountBalance
//                 } = item;
//
//                 return (
//                   <div
//                     key={trxId}
//                     className="w layoutRow fhaS fvaC h114 rlv lh fw7 f12 c2 tc lts0em
//                           ph20 (ph10|w1/8)>1 bgF6F6F6:even"
//                   >
//                     <div>
//                       <Tooltip>{trxType}</Tooltip>
//                     </div>
//                     <div>
//                       <Tooltip>{trxId}</Tooltip>
//                     </div>
//                     <div>
//                       <Tooltip>{orderId}</Tooltip>
//                     </div>
//                     <div>
//                       <Tooltip title={getRFC3339(date)}>
//                         <div>
//                           {formatTime(date, '{dd} {mmm}, {yyyy}')}
//                         </div>
//                         <div className="c717275 fw4 mt8">
//                           {formatTime(date, '{hh}:{MM}:{ss} {TT}')}
//                         </div>
//                       </Tooltip>
//                     </div>
//                     <div>
//                       <Tooltip
//                         className="f12 lh lts0em c2"
//                         title={ccAmount}
//                       >
//                         {formatNumCoin(ccAmount)} {ccCode}
//                       </Tooltip>
//                     </div>
//                     <div>
//                       <Tooltip
//                         className="f12 lh lts0em c2"
//                         title={fiatAmount}
//                       >
//                         {formatNumFiat(fiatAmount)} {fiatCode}
//                       </Tooltip>
//                     </div>
//                     <div>
//                       <Tooltip
//                         className="f12 lh lts0em c2"
//                         title={fee}
//                       >
//                         {formatNumFiat(fee)} {fiatCode}
//                       </Tooltip>
//                     </div>
//                     <div>
//                       <Tooltip
//                         className="f12 lh lts0em c2"
//                         title={accountBalance}
//                       >
//                         {formatNumFiat(accountBalance)} {fiatCode}
//                       </Tooltip>
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         </div>
//       </section>
//     );
//   };
// });
